import { Link, NavLink } from "react-router-dom";
import { RiDashboardFill } from "react-icons/ri";
import { HiDocumentReport } from "react-icons/hi";
import { AiOutlineFileSearch } from "react-icons/ai";
import "./sidebar.scss";

export default function Sidebar() {
  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/" className="logo">
          واجد
        </Link>
      </div>
      <div className="center">
        <NavLink to="/">
          الرئيسية
          <RiDashboardFill />
        </NavLink>
        <NavLink to="/reports">
          عمليات الإبلاغ
          <HiDocumentReport />
        </NavLink>
        <NavLink to="/searches">
          عمليات البحث
          <AiOutlineFileSearch />
        </NavLink>
      </div>
    </div>
  );
}
